import { useEffect } from "react";
import AntdConfig from "./components/AntdConfig";
import UpdatePrompt from "./components/UpdatePrompt";
import MRouter from "./router";
import i18n from "./i18n";
import { applyUILanguageToI18nIfNeeded } from "./utils/personalSettingLanguage";

/** 登入後、設定儲存後、或歷程 cookie 與 i18n 不同步時，依 personal_setting 補正語系 */
function useSyncLanguageFromCookie() {
  useEffect(() => {
    applyUILanguageToI18nIfNeeded(i18n);
  }, []);
}

export default function App() {
  useSyncLanguageFromCookie();
  return (
    <AntdConfig>
      <MRouter />
      {/* SW 註冊與更新提示：需在所有頁面都掛著，故放在 Router 外層 */}
      <UpdatePrompt />
    </AntdConfig>
  );
}
